import { Form, Spin } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../../assets/styles/InterbankPlacement.css";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../contractBooking/contractbooking.config";
import FeedbackModal from "../../../treasury/bond/components/FeedbackModal";
import StepsCard from "../../component/StepsCard";
import StepsComponent from "../../component/StepsComponent";
import { useSearchCustomer } from "../../hooks/useServerActions";
import BondDetailsForm from "./components/BondDetailsForm";
import BondPreviewDetail from "./components/BondPreviewDetails";
import ComplianceChecks from "./components/ComplianceChecks";
import DocumentaryRequirements from "./components/DocumentaryRequirements";
import InvestmentDetails from "./components/InvestmentDetails";
import InvestorInformation from "./components/InvestorInformationForm";
import SuccessModal from "../../component/SuccessModal";
import { getCurrencySymbol } from "../../../../components/facilities/TreasuryFacility";
import ChargeDetails from "./components/ChargeDetails";

const EditBond = (props) => {
  const { state } = useLocation();
  const [current, setCurrent] = useState(0);
  const { userData } = props;
  const { session } = userData;
  const [form] = Form.useForm();
  // const { mutate, loading, data: searchData } = useSearchCustomer(session);
  const selectedProductID = Form.useWatch("productName", form);
  const investorAmount = Form.useWatch("investorAmount", form);

  const [formData, setFormData] = useState({
    investorInformation: null,
    bondDetails: null,
    investmentDetails: null,
    complianceChecks: null,
    documentRequirements: null,
  });

  // const productID = formData.bondDetails?.productName;
  const navigate = useNavigate();
  const [customerData, setCustomerData] = useState(false);
  const [contractDetails, setContractDetails] = useState(false);
  const [currency, setCurrency] = useState(null);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [investorTypeOptions, setInvestorTypeOptions] = useState([]);
  const [bondTypeOptions, setBondTypeOptions] = useState([]);
  const [custodianOptions, setCustodianOptions] = useState([]);
  const [chargeData, setChargeData] = useState(null);

  const [issuerOptions, setIssuerOptions] = useState([]);
  const [couponFrequencyOptions, setCouponFrequencyOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [kycStatusOptions, setKycStatusOptions] = useState([]);
  const [amlScreeningOptions, setAmlScreeningOptions] = useState([]);
  const [sanctionScreeningOptions, setSanctionScreeningOptions] = useState([]);
  const [centralBankReportOptions, setCentralBankReportOptions] = useState([]);
  const [documentStatusOptions, setDocumentStatusOptions] = useState([]);
  const [entityId, setEntityId] = useState(null);
  const [contractRefId, setContractRefId] = useState(null);
  const [showCustomer, setShowCustomer] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [customerSelected, setCustomerSelected] = useState(false);
  const [isCreateButton, setIsCreateButton] = useState(false);
  const [costPerUnit, setCostPerUnit] = useState(null);
  const [couponRate, setCouponRate] = useState(0);

  const getBondContractById = () => {
    const url = `${apiConfig.GetBondContract}/${state.id}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setContractDetails(objDetail);

        form.setFieldsValue({
          investorName: objDetail?.client?.displayName
            ? objDetail?.client?.displayName
            : "-",
          investorType: objDetail?.investorType
            ? objDetail?.investorType?.value
            : null,
          phoneNumber: objDetail?.mobileNo ? objDetail?.mobileNo : "-",
          email: objDetail?.emailAddress ? objDetail?.emailAddress : "-",
          bvn: objDetail?.bvn ? objDetail?.bvn : "-",
          tin: objDetail?.tin ? objDetail?.tin : "-",
          productName: objDetail?.product?.id ? objDetail?.product?.id : "-",
          initiationDate: objDetail?.dealInitiationDate
            ? dayjs(BOM.FormatArrayDate(objDetail?.dealInitiationDate))
            : "-",
          investorAmount: objDetail?.amount ? objDetail?.amount : "",
          purchasePrice: objDetail?.purchasePrice
            ? objDetail?.purchasePrice
            : "",
          numberOfUnitsPurchased: objDetail?.numberOfUnits
            ? objDetail?.numberOfUnits
            : "",
          totalConsideration: objDetail?.totalConsideration
            ? objDetail?.totalConsideration
            : "",
          settlementDate:
            dayjs(BOM.FormatArrayDate(objDetail?.settlementDate)) ?? null,
          settlementAccountNumber: objDetail?.settlementAccount
            ? objDetail?.settlementAccount?.id
            : "",
          kycStatus: objDetail?.kycStatus ? objDetail?.kycStatus?.value : null,
          amlScreening: objDetail?.amlScreening
            ? objDetail?.amlScreening?.value
            : null,
          sanctionsScreening: objDetail?.sanctionScreening
            ? objDetail?.sanctionScreening?.id
            : null,
          centralBankReportingRequirements: objDetail?.centralBankReport
            ? objDetail?.centralBankReport?.id
            : null,
          investorApplicationForm: objDetail?.applicationFormStatus
            ? objDetail?.applicationFormStatus?.value
            : null,
          executedBondPurchaseAgreement: objDetail?.bondPurchaseAgreement
            ? objDetail?.bondPurchaseAgreement?.value
            : null,
          identificationDocuments: objDetail?.identificationDocuments
            ? objDetail?.identificationDocuments?.value
            : null,
          corporateResolution: objDetail?.corporateResolution
            ? objDetail?.corporateResolution?.value
            : null,
          taxClearanceCertificate: objDetail?.taxClearanceCertificate
            ? objDetail?.taxClearanceCertificate?.value
            : null,
        });

        setEntityId(objDetail?.client?.id);
        setContractRefId(objDetail?.contractReferenceId);
        setShowCustomer(true);
        setIsLoading(false);
      }
    });
  };

  function getTemplate() {
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.BondContractTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;

        let tempInvestorTypeOptions = [];
        let tempCustodians = [];
        let tempKycStatusOptions = [];
        let tempAmlScreeningOptions = [];
        let tempSanctionScreeningOptions = [];
        let tempCentralBankReportOptions = [];
        let tempDocumentStatusOptions = [];

        const tempProductOptions = objList?.productOptions
          ?.filter((element) => element.status?.text === "Active")
          .map((element) => ({
            value: element.id,
            label: element.productName,
          }));

        objList?.custodians?.forEach((element) => {
          tempCustodians.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.investorTypeOptions?.forEach((element) => {
          tempInvestorTypeOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.kycStatusOptions?.forEach((element) => {
          tempKycStatusOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.amlScreeningOptions?.forEach((element) => {
          tempAmlScreeningOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.sanctionScreeningOptions?.forEach((element) => {
          tempSanctionScreeningOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.centralBankReportOptions?.forEach((element) => {
          tempCentralBankReportOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.documentStatusOptions?.forEach((element) => {
          tempDocumentStatusOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        setProductOptions(tempProductOptions);
        setCustodianOptions(tempCustodians);
        setInvestorTypeOptions(tempInvestorTypeOptions);
        setKycStatusOptions(tempKycStatusOptions);
        setAmlScreeningOptions(tempAmlScreeningOptions);
        setSanctionScreeningOptions(tempSanctionScreeningOptions);
        setCentralBankReportOptions(tempCentralBankReportOptions);
        setDocumentStatusOptions(tempDocumentStatusOptions);
        setIsLoading(false);

        form.setFieldsValue({
          branchCode: userData?.officeName,
          initiatedBy: userData?.username,
          userID: userData?.userId,
        });
      }
    });
  }

  function getBondTemplate() {
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.BondProductTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempBondTypeOptions = [];
        let tempIssuerOptions = [];
        let tempCouponFrequencyOptions = [];
        let tempCurrencyOptions = [];

        objList?.bondTypes?.forEach((element) => {
          tempBondTypeOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.issuerTypes?.forEach((element) => {
          tempIssuerOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondCouponFrequencies?.forEach((element) => {
          tempCouponFrequencyOptions.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.currencies?.forEach((element) => {
          tempCurrencyOptions.push({
            value: element.code,
            label: element.displayLabel,
            symbol: element.displaySymbol,
          });
        });

        setBondTypeOptions(tempBondTypeOptions);
        setIssuerOptions(tempIssuerOptions);
        setCouponFrequencyOptions(tempCouponFrequencyOptions);
        setCurrencyOptions(tempCurrencyOptions);
        setIsLoading(false);
      }
    });
  }

  const getBondProductById = (params) => {
    const url = `${apiConfig.GetBondProduct}/${params}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;

        form.setFieldsValue({
          key: objDetail?.id,
          initiationDate: dayjs(),
          issueDate: dayjs(),
          bondType: objDetail?.bondType?.value ?? null,
          issuer: objDetail?.bondIssuerName ?? "",
          currency: objDetail?.currencyCode ?? "",
          maturityDate:
            dayjs(BOM.FormatArrayDate(objDetail?.maturityDate)) ?? null,
          settlementDate:
            dayjs(BOM.FormatArrayDate(objDetail?.maturityDate)) ?? null,
          tenor: objDetail?.bondTenor ?? "",
          couponRate: objDetail?.fixedCouponRate ?? "",
          couponFrequency: objDetail?.bondCouponFrequency?.value ?? null,
          custodian: objDetail?.custodian?.id ?? null,
        });

        setChargeData({
          commission: objDetail?.commission,
          setupCharge: objDetail?.setupCharge,
          redemptionCharge: objDetail?.redemptionCharge,
          transferCharge: objDetail?.transferCharge,
          allowTax: objDetail?.allowTax,
          taxGroup: objDetail?.taxGroup,
          setupCharges: objDetail?.setupCharges,
          redemptionCharges: objDetail?.redemptionCharges,
          transferCharges: objDetail?.transferCharges,
          allowBrokerage: objDetail?.allowBrokerage,
        });

        setIsLoading(false);
        setCouponRate(objDetail?.fixedCouponRate);
        setCostPerUnit(objDetail?.faceValue);
        setCurrency(objDetail?.currencyCode);
      }
    });
  };

  const getAccountOverviewList = (param) => {
    const url = `${apiConfig.Clients}/${param}/accounts`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempSavingsArray = [];
        let tempAccountOptions = [];

        // prepare table for savings, current, term deposit accounts
        objList?.savingsAccounts
          ?.filter((item) => item?.status?.active === true)
          ?.forEach((element) => {
            tempSavingsArray.push({
              value: element?.id,
              label: `${element?.accountNo || "-"} - ${
                element?.productName || "-"
              }`,
              // Keep all original data
              ...element,
              key: element?.id,
              id: element?.id,
              accountNo: element?.accountNo || "-",
              productName: element?.depositType.value || "-",
              status:
                element?.status.active === true
                  ? "Active"
                  : element?.status.active === false
                  ? "Closed"
                  : "-",
            });
          });

        tempSavingsArray?.forEach((element) => {
          tempAccountOptions.push({
            value: element.id,
            label: `${element.depositType.value} - ${element.accountNo}`,
          });
        });

        setAccountOptions(tempAccountOptions);
      }
    });
  };

  useEffect(() => {
    // On initial mount
    getBondContractById();
    getTemplate();
    getBondTemplate();
  }, []);

  useEffect(() => {
    if (!entityId) return;

    getCustomerDetailById(entityId);
    getAddresses(entityId);
    getAccountOverviewList(entityId);
  }, [entityId]);

  useEffect(() => {
    if (!selectedProductID) return;

    getBondProductById(selectedProductID);
  }, [selectedProductID]);

  useEffect(() => {
    const purchasePrice = Number(
      investorAmount - investorAmount * (couponRate / 100)
    );

    const numberOfUnits = Number(investorAmount / costPerUnit);

    form.setFieldsValue({
      purchasePrice:
        Number(purchasePrice).toFixed(2) || contractDetails?.purchasePrice,
      numberOfUnitsPurchased:
        Number(numberOfUnits) || contractDetails?.numberOfUnits,
    });
  }, [investorAmount, couponRate, contractDetails, costPerUnit, form]);

  const updateFormData = (section, newData) => {
    setFormData((prevData) => ({
      ...prevData,
      [section]: {
        ...prevData[section],
        ...newData,
      },
    }));
  };

  function onFinish(newData) {
    setFormData({
      ...formData,
      ...newData,
    });
    setCurrent(current + 1);
  }

  function next() {
    const stepsUsingForm = [0, 1, 3, 4, 5]; // indices of steps

    if (stepsUsingForm.includes(current)) {
      form.submit(); // only those steps trigger onFinish
    } else {
      setCurrent(current + 1);
    }
  }

  function prev() {
    const prevStep = current - 1;
    setCurrent(prevStep);
    setCompletedSteps((prev) => {
      const updated = prev.filter((stepIndex) => stepIndex < prevStep);
      return updated;
    });
  }

  const getCustomerDetailById = (param) => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${param}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        form.setFieldsValue({
          key: objDetail?.id,
          id: objDetail?.id,
          investorName: objDetail?.displayName ? objDetail?.displayName : "-",
          phoneNumber: objDetail?.mobileNo ? objDetail?.mobileNo : "-",
          email: objDetail?.emailAddress ? objDetail?.emailAddress : "-",
          bvn: objDetail?.bvn ? objDetail?.bvn : "-",
          tin: objDetail?.tin ? objDetail?.tin : "-",
        });

        const tempObj = {
          entityAccountNo: objDetail.accountNo ?? "",
          entityId: objDetail.id ?? "",
          entityName:
            objDetail.displayName ??
            `${objDetail.firstname ?? ""} ${objDetail.lastname ?? ""}`.trim(),
          entityType: objDetail.legalForm?.value ?? "",
          entityBranch: objDetail.officeName ?? "",
        };

        setCustomerData(tempObj);
        setCustomerSelected(true);
        setIsLoading(false);
      }
    });
  };

  const getAddresses = (param) => {
    setIsLoading(true);

    const url = `${apiConfig.Client}/${param}/addresses`;
    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;

        const address = objDetail[0];

        form.setFieldsValue({
          key: address?.id,
          id: address?.id,
          address: address?.addressLine1 ? address?.addressLine1 : "-",
          city: address?.city ? address?.city : "-",
        });
        setIsLoading(false);
      }
    });
  };

  // const handleSearch = async (searchId) => {
  //   try {
  //     const res = await mutate(searchId);

  //     getCustomerDetailById(res.entityId);
  //     getAddresses(res.entityId);
  //     getAccountOverviewList(res.entityId);
  //     setEntityId(res.entityId);
  //   } catch (error) {
  //     console.error("Error during search:", error);
  //   }
  // };

  const handleSubmit = () => {
    let formValues = {
      ...formData.investmentDetails,
      ...formData.complianceChecks,
      ...formData.documentRequirements,
    };

    formValues.clientId = entityId;
    formValues.investerType =
      formData?.investorInformation?.investorType ?? formData?.investorType;
    formValues.productId =
      formData?.bondDetails?.productName ?? formData?.productName;
    formValues.bondType = formData?.bondDetails?.bondType ?? formData?.bondType;
    formValues.custodian =
      formData?.bondDetails?.custodian ?? formData?.custodian;
    formValues.tenor = formData?.bondDetails?.tenor ?? formData?.tenor;
    formValues.issuer = formData?.bondDetails?.issuer ?? formData?.issuer;
    formValues.issueDate = formData?.bondDetails?.issueDate
      ? BOM.DateTime(formData.bondDetails.issueDate, "only-date")
      : formData?.issueDate
      ? BOM.DateTime(formData.issueDate, "only-date")
      : undefined;
    formValues.dealInitiationDate = formData?.bondDetails?.initiationDate
      ? BOM.DateTime(formData.bondDetails.initiationDate, "only-date")
      : formData?.initiationDate
      ? BOM.DateTime(formData.initiationDate, "only-date")
      : undefined;
    formValues.amount = formValues?.investorAmount ?? formData?.investorAmount;
    formValues.numberOfUnits =
      formValues?.numberOfUnitsPurchased ?? formData?.numberOfUnitsPurchased;
    formValues.settlementAccountId =
      formValues?.settlementAccountNumber ?? formData?.settlementAccountNumber;
    formValues.sanctionScreening =
      formValues?.sanctionsScreening ?? formData?.sanctionsScreening;
    formValues.centralBankReport =
      formValues?.centralBankReportingRequirements ??
      formData?.centralBankReportingRequirements;
    formValues.applicationFormStatus =
      formValues?.investorApplicationForm ?? formData?.investorApplicationForm;
    formValues.bondPurchaseAgreement =
      formValues?.executedBondPurchaseAgreement ??
      formData?.executedBondPurchaseAgreement;
    formValues.settlementDate = formValues.settlementDate
      ? BOM.DateTime(formValues.settlementDate, "only-date")
      : formData?.settlementDate
      ? BOM.DateTime(formData.settlementDate, "only-date")
      : undefined;
    formValues.purchasePrice =
      formValues?.purchasePrice || formData?.purchasePrice;
    formValues.totalConsideration =
      formValues?.totalConsideration || formData?.totalConsideration;
    formValues.kycStatus = formValues?.kycStatus || formData?.kycStatus;
    formValues.amlScreening =
      formValues?.amlScreening || formData?.amlScreening;
    formValues.identificationDocuments =
      formValues?.identificationDocuments || formData?.identificationDocuments;
    formValues.corporateResolution =
      formValues?.corporateResolution || formData?.corporateResolution;
    formValues.taxClearanceCertificate =
      formValues?.taxClearanceCertificate || formData?.taxClearanceCertificate;
    formValues.issuerRiskRating = 1;
    formValues.marketRiskConsideration = 1;
    formValues.concentrationRisk = 1;

    delete formValues.bondDetails;
    delete formValues.investorInformation;
    delete formValues.investorType;
    delete formValues.documentRequirements;
    delete formValues.investmentDetails;
    delete formValues.complianceChecks;
    delete formValues.sanctionsScreening;
    delete formValues.centralBankReportingRequirements;
    delete formValues.investorName;
    delete formValues.investorApplicationForm;
    delete formValues.executedBondPurchaseAgreement;
    delete formValues.investorAmount; // remove after fix
    delete formValues.numberOfUnitsPurchased; // remove after fix
    delete formValues.settlementAccountNumber; // remove after fix

    const url = `${apiConfig.EditBondContract}/${state.id}`;

    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        setSuccessModalVisible(true);
        setIsLoading(false);
      }
    });
  };

  const handleInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleClose = () => {
    setSuccessModalVisible(false);
    setWarningModalVisible(false);
  };

  function onCancel() {
    navigate("/bond-contract", { replace: false });
  }

  const currencySymbol = getCurrencySymbol(currency, currencyOptions);

  const stepsContent = [
    {
      title: "Investor Information",
      component: (
        <InvestorInformation
          // handleSearch={handleSearch}
          searchData={customerData}
          formData={formData}
          form={form}
          updateFormData={(data) => updateFormData("investorInformation", data)}
          onFinish={onFinish}
          handleInputChange={handleInputChange}
          investorTypeOptions={investorTypeOptions}
          isEdit={true}
          showCustomer={showCustomer}
          customerSelected={customerSelected}
        />
      ),
    },
    {
      title: "Bond Details",
      component: (
        <BondDetailsForm
          formData={formData}
          form={form}
          updateFormData={(data) => updateFormData("bondDetails", data)}
          onFinish={onFinish}
          handleInputChange={handleInputChange}
          productOptions={productOptions}
          bondTypeOptions={bondTypeOptions}
          issuerOptions={issuerOptions}
          currencyOptions={currencyOptions}
          couponFrequencyOptions={couponFrequencyOptions}
          currencySymbol={currencySymbol}
          custodianOptions={custodianOptions}
        />
      ),
    },
    {
      title: "Charge Details",
      component: (
        <ChargeDetails
          chargeData={chargeData}
          currencySymbol={currencySymbol}
        />
      ),
    },
    {
      title: "Investment Details",
      component: (
        <InvestmentDetails
          formData={formData}
          form={form}
          updateFormData={(data) => updateFormData("investmentDetails", data)}
          onFinish={onFinish}
          handleInputChange={handleInputChange}
          accountOptions={accountOptions}
          currencySymbol={currencySymbol}
        />
      ),
    },
    {
      title: "Compliance Checks",
      component: (
        <ComplianceChecks
          formData={formData}
          form={form}
          updateFormData={(data) => updateFormData("complianceChecks", data)}
          onFinish={onFinish}
          handleInputChange={handleInputChange}
          kycStatusOptions={kycStatusOptions}
          amlScreeningOptions={amlScreeningOptions}
          sanctionScreeningOptions={sanctionScreeningOptions}
          centralBankReportOptions={centralBankReportOptions}
        />
      ),
    },
    {
      title: "Document Requirements",
      component: (
        <DocumentaryRequirements
          formData={formData}
          form={form}
          updateFormData={(data) =>
            updateFormData("documentRequirements", data)
          }
          onFinish={onFinish}
          documentStatusOptions={documentStatusOptions}
          userData={userData}
          entityId={entityId}
        />
      ),
    },
    {
      title: "Preview",
      component: (
        <BondPreviewDetail
          formData={formData}
          investorTypeOptions={investorTypeOptions}
          productOptions={productOptions}
          bondTypeOptions={bondTypeOptions}
          issuerOptions={issuerOptions}
          couponFrequencyOptions={couponFrequencyOptions}
          accountOptions={accountOptions}
          kycStatusOptions={kycStatusOptions}
          amlScreeningOptions={amlScreeningOptions}
          sanctionScreeningOptions={sanctionScreeningOptions}
          centralBankReportOptions={centralBankReportOptions}
          documentStatusOptions={documentStatusOptions}
          contractRefId={contractRefId}
          chargeData={chargeData}
          currencySymbol={currencySymbol}
          custodianOptions={custodianOptions}
        />
      ),
    },
  ];

  return (
    <MainLayout
      pageItems={staticConfig.editContractBookingBond}
      onSave={handleSubmit}
    >
      <TopContent
        pageTitle={labelConfig.manageContractBookingBond}
        createPageTitle={labelConfig.updateContractBookingBond}
      />

      <Spin spinning={isLoading} size="large">
        <div
          className="contract-form-container"
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            height: "720px",
            widtth: "100%",
          }}
        >
          {/* Left side - Vertical steps */}
          <StepsComponent
            steps={stepsContent}
            current={current}
            completedSteps={completedSteps}
          />

          <StepsCard
            current={current}
            onNext={next}
            onPrev={prev}
            totalSteps={7}
            submitLabel={"Update Contract"}
            nextLabel={`Next - ${stepsContent[current + 1]?.title || ""}`}
            onSubmit={handleSubmit}
            onGoBack={onCancel}
          >
            {stepsContent[current].component}
          </StepsCard>

          {/* Success Modal */}
          {/* <FeedbackModal
            visible={successModalVisible}
            type="success"
            onPrimaryAction={onCancel}
            onClose={handleClose}
            message="Bond Contract has been successfully updated."
            primaryButtonText="Close"
          /> */}
          <SuccessModal
            visible={successModalVisible}
            onClose={onCancel}
            // onClose={handleClose}
            successMessage={"Your Bond Contract has been updated successfully."}
            isCreateButton={isCreateButton}
          />

          {/* Warning Modal */}
          <FeedbackModal
            visible={warningModalVisible}
            type="warning"
            onPrimaryAction={() => {
              onCancel();
            }}
            onSecondaryAction={() => {
              handleClose();
            }}
            onClose={handleClose}
          />
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditBond);
